import { useEffect, useState } from "react";

import PaymentMethodSelection from "features/payment-methods/components/PaymentMethod/PaymentMethodSelection";
import usePaymentSources from "features/payment-methods/datahooks/usePaymentSources";
import type { PaymentSource } from "features/payment-methods/types";

import Loader from "common/components/Loader";

import AddPaymentMethod from "./AddPaymentMethod";

export interface PaymentMethodProps {
  initialPaymentSource: PaymentSource;
  onBack: () => void;
  setPaymentSource: (paymentSource: PaymentSource) => void;
  isSettingPaymentSource?: boolean;
  setPaymentSourceError?: Error;
}

export default function PaymentMethod({
  initialPaymentSource,
  onBack,
  setPaymentSource,
  isSettingPaymentSource,
  setPaymentSourceError,
}: PaymentMethodProps) {
  const { paymentSources, isLoadingPaymentSources } = usePaymentSources();
  const [isAddingPaymentMethod, setIsAddingPaymentMethod] = useState(false);

  useEffect(() => {
    if (!isLoadingPaymentSources && paymentSources) {
      setIsAddingPaymentMethod(!paymentSources.length);
    }
  }, [paymentSources, isLoadingPaymentSources]);

  if (isLoadingPaymentSources) return <Loader className="my-40" />;

  if (isAddingPaymentMethod)
    return (
      <AddPaymentMethod
        setPaymentSource={setPaymentSource}
        onBack={
          paymentSources.length ? () => setIsAddingPaymentMethod(false) : onBack
        }
      />
    );

  return (
    <PaymentMethodSelection
      selectedPaymentSource={initialPaymentSource}
      addPaymentMethod={() => setIsAddingPaymentMethod(true)}
      onBack={onBack}
      setPaymentSource={setPaymentSource}
      isSettingPaymentSource={isSettingPaymentSource}
      setPaymentSourceError={setPaymentSourceError}
    />
  );
}
